import { ChevronForwardOutlineIc, ShieldCheckmark2Ic } from '@dsch/dd-icons';

import {
  CertifiedTrustedDealerEntryPointCopy,
  DoneDealMotorLink,
} from './DoneDealCertifiedTrustedDealerLink.styled';

import { theme } from '../../../../helpers/Theme';
import { restoreScrollPosition } from '../../../../helpers/scroll';
import { ThemeTypes } from '../../../../types/Theme.namespace';

const CERTIFIED_TRUSTED_DEALER_URL = '/cars?trustedDealer=true';

const LABEL = 'View Certified Trusted Dealer Cars';

export const DoneDealCertifiedTrustedDealerLink = ({
  colorVariant = 'GREY_DARKER',
}: {
  colorVariant?: ThemeTypes.Colors;
}) => {
  return (
    <DoneDealMotorLink
      href={CERTIFIED_TRUSTED_DEALER_URL}
      ofType="SECONDARY"
      colorVariant={colorVariant}
      fontSize="M16"
      data-testid="certified-trusted-dealer-hero-entry-point"
      onClick={() => {
        restoreScrollPosition(CERTIFIED_TRUSTED_DEALER_URL);
      }}
      data-tracking="certified-trusted-dealer-cars-homepage-entry-point"
      aria-label={LABEL}
    >
      <ShieldCheckmark2Ic width={16} height={16} color={theme.colors.GREEN} />
      <CertifiedTrustedDealerEntryPointCopy>
        {LABEL}
      </CertifiedTrustedDealerEntryPointCopy>
      <ChevronForwardOutlineIc
        color={theme.colors[colorVariant]}
        height={16}
        width={16}
      />
    </DoneDealMotorLink>
  );
};
